import Subscription, { ISubscription } from '@aytm/lib/common/subscription'
import { isSubset } from '@aytm/lib/common/object'

import DevLog from '../devlog/Module'

import { ModuleID } from '../types'
import { IThemeModule, IWidgetStyle } from './types'

export const DEFAULT_ACCENT_COLOR = '#4FC2E8'

let currentStyle: IWidgetStyle = Object.freeze({
  accentColor: DEFAULT_ACCENT_COLOR,
  backgroundColor: null,
  backgroundFit: null,
  backgroundImage: null,
  backgroundTile: null,
  pb: true,
  tp: true
})

let updateSubscription: ISubscription<IThemeModule> = null

let moduleLoaded = false
const ThemeModule: IThemeModule = {
  get id(): ModuleID {
    return ModuleID.THEME
  },
  config({ style } = {}) {
    if (style) {
      ThemeModule.updateStyle(style)
    }
    return ThemeModule
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(ThemeModule)
  },
  get loaded() {
    return moduleLoaded
  },
  get style() {
    return currentStyle
  },
  rgbHex2hsl(rgbHex) {
    // Convert HEX to RGB
    const hexCode = rgbHex.replace(/^#/, '')
    const R = parseInt(hexCode.slice(0, 2), 16) || 0
    const G = parseInt(hexCode.slice(2, 4), 16) || 0
    const B = parseInt(hexCode.slice(4, 6), 16) || 0
    // Convert RGB to [0,1] range
    const Rn = Math.max(0, Math.min(1, R / 255))
    const Gn = Math.max(0, Math.min(1, G / 255))
    const Bn = Math.max(0, Math.min(1, B / 255))
    // Get the min and max of RGB
    const min = Math.min(Rn, Gn, Bn)
    const max = Math.max(Rn, Gn, Bn)
    // Lightness is the average of the largest and smallest color components
    const L = (min + max) * 0.5
    // Saturation in [0,1] range
    const S = max === min && 0 === max ? 0 : L <= 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min)
    // Hue in degrees
    const H =
      60 *
      (min === max
        ? 0
        : Rn === max
        ? (Gn - Bn) / (max - min)
        : Gn === max
        ? 2 + (Bn - Rn) / (max - min)
        : 4 + (Rn - Gn) / (max - min))
    // Correct for hue < 0 and round
    const Hn = Math.round(H < 0 ? H + 360 : H)
    // Convert to percentage and round
    const Sn = Math.round(S * 100)
    // Convert to percentage and round
    const Ln = Math.round(L * 100)
    return [Hn, Sn, Ln]
  },
  accentAtoB(accentA_HSL) {
    return [accentA_HSL[0], Math.max(0, accentA_HSL[1] - 4), Math.max(0, accentA_HSL[2] - 14)]
  },
  updateStyle(style) {
    if (style && !isSubset(style, currentStyle)) {
      currentStyle = Object.freeze({ ...currentStyle, ...style })
      DevLog._moduleLog(ThemeModule, 'updateStyle', currentStyle)
      if (null != updateSubscription) {
        updateSubscription.update(ThemeModule)
      }
    }
    return ThemeModule
  },
  onUpdate(listener) {
    if (null == updateSubscription) {
      updateSubscription = Subscription<IThemeModule>()
    }
    return updateSubscription.listen(listener)
  }
}

export default ThemeModule
